import { render, staticRenderFns } from "./AuthFormComponent.vue?vue&type=template&id=31ad3192"
import script from "./AuthFormComponent.vue?vue&type=script&lang=js"
export * from "./AuthFormComponent.vue?vue&type=script&lang=js"
import style0 from "./AuthFormComponent.vue?vue&type=style&index=0&id=31ad3192&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports